<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="订单处理"></pt-page-title>
    <!-- tabs -->
    <el-tabs v-model="currentStatusFilter" @tab-click="handleClick" slot="title">
      <!-- TZ: 待处理里不显示WAITING_FOR_JOB
      <el-tab-pane label="待处理" name="WAITING_FOR_JOB,ACTION_REQUIRED"></el-tab-pane>-->
      <el-tab-pane label="待处理" name="ACTION_REQUIRED"></el-tab-pane>
      <el-tab-pane label="已处理" name="COMPLETED,WAITING_FOR_NEW_ORDER"></el-tab-pane>
    </el-tabs>
    <!-- 筛选 -->
    <pt-page-factor-filter :labels="filterLabels" v-model="filterForm">
      <el-button type="primary" @click="handleFilter">筛选</el-button>
    </pt-page-factor-filter>
    <!-- 表格 -->
    <pt-order-handle-table :tableLabels="currentTableLabels" :status="currentStatusFilter" ref="table">
        <el-table-column label="操作" v-if="currentStatusFilter=='ACTION_REQUIRED'" fixed="right" min-width="200">
            <template slot-scope="scope">
              <task-operate :task="scope.row" @on-success="onSuccess" @before-submit="showLoading" @on-error="onError"></task-operate>
                <!-- <el-button v-for="(item,index) in scope.row.orderActionData.futureActionAcceptableResults" :key="index" type="primary" size="mini" @click="handleButtonConfirm(scope.row,item)">{{formatActionAcceptableResult(item)}}</el-button> -->
                <!-- <el-button type="primary" size="mini" @click="handleButtonConfirm(scope.row,'MUTATION_VERIFICATION')">{{formatActionAcceptableResult('MUTATION_VERIFICATION')}}</el-button> -->
            </template>
        </el-table-column>
    </pt-order-handle-table>
    <!-- 处理的dialog -->
    <!-- <order-handle-dialog :dialogVisible="dialogVisible" :handle-close="closeDialog" :sampleId="currentSampleId" :operate="operate" :title="dialogTitle" :handle-submit="certainSubmit"></order-handle-dialog> -->
  </div>
</template>

<script>
// 组件class前缀
import { filterFactor, filterFactorCopy, tableLabels, tableLabelsOk } from './order-handle-options.js'
import ptOrderHandleTable from './pt-order-handle-table/withData'
import taskOperate from 'cps/lab-order/order-status/form/components/task-operate'
// import dialog from './dialog.vue'
import { formatActionAcceptableResult } from 'enumeration/lab-order.js'
import { getSignature } from '@/utils/action'
const prefixCls = 'pt-order-handle'
export default {
  name: 'pt-order-handle',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      if (this.currentStatusFilter === 'COMPLETED,WAITING_FOR_NEW_ORDER') {
        return tableLabelsOk
      }
      return tableLabels
    },
    filterLabels () {
      if (this.currentStatusFilter === 'COMPLETED,WAITING_FOR_NEW_ORDER') {
        return filterFactorCopy
      }
      return filterFactor
    }
  },
  components: {
    ptOrderHandleTable,
    taskOperate
    // 'order-handle-dialog': dialog
  },
  data () {
    return {
      loading: false,
      filterForm: {},
      currentStatusFilter: this.$route.params.status,
      dialogVisible: false,
      currentSampleId: '',
      // 操作
      operate: '',
      dialogTitle: '',
      submitParams: {},
      saveFileName: ''
    }
  },
  methods: {
    formatActionAcceptableResult,
    handleClick (tab) {
      this.handleFilter()
      this.$router.push({ name: 'order-handle', params: { status: tab.name } })
    },
    handleFilter () {
      if (this.filterForm.orderActions === '') {
        this.filterForm.orderActions = null
      }
      this.filterForm.status = this.currentStatusFilter.split(',')
      this.filterForm.pageable = { page: 0, size: 10 }
      this.$refs.table.reload(this.filterForm)
    },
    handleButtonConfirm (data, message) {
      console.log('data', data)
      let dialogOpen = ['SAMPLE_RECOLLECT', 'MUTATION_VERIFICATION']
      this.submitParams.taskId = data.id
      this.submitParams.statusResult = message
      if (dialogOpen.includes(message)) {
        this.dialogVisible = true
        this.operate = message
        this.dialogTitle = formatActionAcceptableResult(message)
        this.currentSampleId = data.orderActionData.order.currentSample.sampleId
      } else {
        this.$confirm('该订单将进行“' + formatActionAcceptableResult(message) + '”操作，是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.certainSubmit()
        })
      }
    },
    closeDialog () {
      this.dialogVisible = false
    },
    async submit (data) {
      console.log('data----', data)
      this.loading = true
      if (data) {
        if (data.sampleRecollectCost) {
          this.submitParams.sampleRecollectCost = Number(data.sampleRecollectCost) * 100// 重采
          return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
        }
        if (data.file) {
          // let uploadParams = new FormData(data.file)
          // uploadParams.append('file', data.file)
          try {
            let params = { resourceConfig: 'mutationVerify', type: 'PRIVATE_RESOURCE', objectId: new Date().getTime(), name: data.file.name }
            var response = await this.$store.dispatch('ossUploadBigFile', params)
            console.log('response', response.data)
            try {
              let uploadParams = new FormData()
              // // var blob = new Blob([data.file], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              uploadParams.append('AccessKeyId', response.data.accesskeyid)
              uploadParams.append('policy', response.data.policy)
              uploadParams.append('signature', response.data.signature)
              this.saveFileName = response.data.key
              uploadParams.append('file', data.file)
              uploadParams.append('key', response.data.key)
              // uploadParams.append('x-obs-acl', response.data['x-obs-acl'])
              uploadParams.append('content-type', response.data['content-type'])

              // this.uploadForm.append('success_action_status', 200) // 指定返回的状态码，默认为204
              // this.$axios(url,data)
              let uploadRes = await getSignature(response.data.host, uploadParams)
              // let uploadParams = {
              //   OSSAccessKeyId: response.data.accessid,
              //   policy: response.data.policy,
              //   Signature: response.data.signature,
              //   key: this.saveFileName,
              //   file: data.file
              // }
              // let uploadRes = await test(response.data.host, uploadParams)
              console.log('uploadRes', uploadRes)
              if (uploadRes.status === 204) {
                console.log('this.saveFileName', this.saveFileName)
                // ---对应字段
                let fileObj = {}
                fileObj.ossUrl = this.saveFileName
                fileObj.type = 'VERIFICATION_REQUEST'
                fileObj.name = data.file.name
                this.submitParams.attachment = {
                  ossUrl: this.saveFileName,
                  type: 'VERIFICATION_REQUEST',
                  name: data.file.name
                }
                return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
              } else {
                this.loading = false
                this.$message.error('文件上传失败')
              }
            } catch (err) {
              console.log(err)
              this.loading = false
              this.$message.error('文件上传失败！')
            }
          } catch (err) {
            console.log(err)
            this.loading = false
            this.$message.error('获取签名失败！')
          }
        }
      }
      return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
    },
    onSuccess () {
      this.hideLoading()
      this.$refs.table.reload()
    },
    showLoading () {
      this.loading = true
    },
    hideLoading () {
      this.loading = false
    },
    onError () {
      this.hideLoading()
    },
    certainSubmit (data) {
      this.submit(data).then(res => {
        this.loading = false
        if (res.message) {
          this.$message.warning(res.message)
        } else {
          this.$message.success('操作成功！')
        }
        this.$refs.table.reload()
        console.log('res', res)
      }).catch(err => {
        this.loading = false
        this.$message.warning(err)
      })
    }
  }

}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-order-handle {
  .el-tabs {
    display: inline-block;
  }
  .el-tabs--top .el-tabs__nav {
    padding-left: 30px;
    padding-right: 30px;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-tabs__active-bar {
    left: 30px;
  }
  .el-button--mini {
    margin-bottom: 10px;
  }
}
</style>
